import React from "react";
import "./PrivacidadyTerminos.css";
import Grid from "@material-ui/core/Grid";

function PrivTerm() {
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="contenedor-legal">
            <div className="card margin1">
              <div className="card-body cuerpo-legal">
                <h5 className="card-title">Privacidad</h5>
                <ul>
                  <li className="roman">
                    <br />
                    Para utilizar los Servicios ofrecidos por SANID, los
                    Usuarios deberán facilitar determinados datos de carácter
                    personal. Su información personal se procesa y almacena en
                    servidores o medios magnéticos que mantienen altos
                    estándares de seguridad y protección tecnológica.{" "}
                  </li>
                  <li className="roman">
                    <br />
                    SANID recaba tu información personal para que puedas
                    disfrutar de nuestros servicios, y poder mejorarlos de
                    manera continua. En algunos casos, la información la
                    facilitas tu mismo, al registrarte o al proveer información
                    cuando utilizas alguno de nuestros servicios. También
                    podemos recabar información acerca tuyo de otras fuentes
                    confiables. Queremos que sepas que no tienes la obligación
                    de proporcionarnos la información personal que se muestra a
                    continuación, sin embargo, este es un requisito esencial
                    para poder contratar y/o tener cualquier tipo de relación
                    con SANID y, si no proporcionas esta información, no
                    podremos brindarte nuestros servicios o nuestra capacidad
                    para hacerlo puede verse significativamente obstaculizada.
                    La inexactitud o falsedad de los datos personales que
                    proporciones podría causar la suspensión de los Servicios.
                  </li>
                  <li className="roman">
                    <br />
                    El resguardo de tu privacidad es muy importante para SANID.
                    Por ello no vendemos ni comercializamos información que
                    identifique a nuestros usuarios. Tampoco compartimos o
                    transferimos de ningún otro modo tu Información Personal a
                    terceros, salvo de la manera indicada a continuación: SANID
                    podrá ceder, transmitir y/o transferir tu Información
                    Personal a: (i) "Proveedores de Servicios": los proveedores
                    de servicios o empresas de outsourcing son terceros que
                    contratamos para que actúen en nombre de SANID para que
                    presten un servicio siguiendo nuestras instrucciones y de
                    conformidad a lo establecido en esta Declaración de
                    Privacidad, para contribuir a mejorar o facilitar las
                    operaciones a través de nuestra plataforma, como: (a)
                    empresas de mensajería, para hacerte llegar los productos
                    que adquiriste, para obtener el pago por los servicios o
                    productos contratados, (b) proveedores de sistemas
                    informáticos, proveedores de servicios en la nube,
                    proveedores de bases de datos, y proveedores de servicios
                    tecnológicos en general, (c) call centers o centros de
                    atención al cliente, (d) empresas que manejen programas de
                    fidelidad o lealtad, para otorgarte beneficios. Estos
                    Proveedores de Servicios sólo acceden a la información
                    estrictamente necesaria para prestar los servicios acordados
                    y no pueden usarlos para finalidades distintas a las que les
                    encomiende SANID. Asimismo, SANID podrá divulgar tu
                    Información Personal discrecionalmente a otros usuarios de
                    los Sitios Web y/o los Servicios, entidades o terceros
                    cuando haya motivos suficientes para considerar que tu
                    actividad sea sospechosa de intentar o cometer un delito o
                    intentar perjudicar a otras personas. También, prestas tu
                    consentimiento expreso e informado para que SANID ceda,
                    transmita o transfiera tu Información Personal a los
                    destinatarios detallados en esta Declaración de Privacidad.
                    Finalmente, SANID no será responsable por el uso indebido de
                    tu Información Personal que haga cualquier tercero cuando
                    sean éstos terceros quienes directamente recolecten y/o
                    traten tu Información Personal. El usuario será responsable
                    de todos los actos que tengan lugar mediante el uso de su
                    apodo.
                  </li>
                  <li className="roman">
                    <br />
                    Menores de Edad: Los Servicios de SANID sólo están
                    disponibles para aquellas personas que tengan capacidad
                    legal para contratar conforme la normativa aplicable. Por lo
                    tanto, si no cumples con esta condición, no deberás
                    suministrar tu Información Personal.
                  </li>
                  <li className="roman">
                    <br />
                    Enlaces a otros Sitios Web: A través de los Sitios Web,
                    SANID podría incluir enlaces a sitios web de terceros, lo
                    cual no indica que sean propiedad de, o sean operados por,
                    SANID. Se aclara que el procesamiento de la Información
                    Personal que hagan los terceros responsables de los sitios
                    web antes mencionados no está alcanzado por esta Declaración
                    de Privacidad. Asimismo, reconoces y aceptas que SANID no
                    tiene control sobre tales sitios web y no es ni será
                    responsable por el contenido ni por los servicios prestados
                    por tales sitios, ni por el modo en que éstos procesen tu
                    Información Personal, por lo que ingresas a dichos sitios
                    web bajo tu propia responsabilidad.
                  </li>

                  <li className="roman">
                    <br />
                    Propiedad intelectual - Licencia - Enlaces SANID y/o sus
                    sociedades controlantes, controladas, filiales o
                    subsidiarias se reservan todos los derechos, incluyendo los
                    derechos de propiedad intelectual e industrial, asociados
                    con los servicios de SANID, sus sitios web, los contenidos
                    de sus pantallas, programas, bases de datos, redes, códigos,
                    desarrollo, software, arquitectura, hardware, contenidos,
                    información, tecnología, fases de integración,
                    funcionalidades, dominios, archivos que permiten al Usuario
                    acceder, herramientas de venta, marcas, patentes, derechos
                    de autor, diseños y modelos industriales, nombres
                    comerciales, entre otros, y declara que están protegidos por
                    leyes nacionales e internacionales vigentes. En ningún caso
                    se entenderá que el Usuario tendrá algún tipo de derecho
                    sobre los mismos excepto para utilizar el servicio de SANID
                    conforme a lo previsto en estos Términos y Condiciones
                    Generales. El uso indebido o contrario a la normativa
                    vigente de los derechos de propiedad intelectual e
                    industrial de SANID, así como su reproducción total o
                    parcial, queda prohibido, salvo autorización expresa y por
                    escrito de SANID. El sitio puede contener enlaces a sitios
                    web de terceros. En virtud que Mercado Libre no tiene
                    control sobre tales sitios, no será responsable por los
                    contenidos, materiales, acciones y/o servicios prestados por
                    los mismos, ni por daños o pérdidas ocasionadas por la
                    utilización de éstos, causados directa o indirectamente. La
                    presencia de enlaces a otros sitios web no implica una
                    sociedad, relación, aprobación, respaldo de Mercado Libre
                    con dichos sitios y sus contenidos.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="contenedor-legal">
            <div className="card margin2">
              <div className="card-body cuerpo-legal">
                <h5 className="card-title">Términos Legales</h5>
                <p className="card-text">
                  Esta página web es propiedad y está operado por
                  https://www.sanid.com.ar/. Estos Términos establecen los
                  términos y condiciones bajo los cuales tu puedes usar nuestra
                  página web y servicios ofrecidos por nosotros. Esta página web
                  ofrece a los visitantes información sobre nosotros, nuestros
                  objetivos y sobre los servicios que brindamos. Al acceder o
                  usar la página web de nuestro servicio, usted aprueba que haya
                  leído, entendido y aceptado estar sujeto a estos Términos:
                </p>
                <ul>
                  <li className="roman">
                    <br />
                    El Servicio y todos los materiales incluidos o transferidos,
                    incluyendo, sin limitación, software, imágenes, texto,
                    gráficos, logotipos, patentes, marcas registradas, marcas de
                    servicio, derechos de autor, fotografías, audio, videos,
                    música y todos los Derechos de Propiedad Intelectual
                    relacionados con ellos, son la propiedad exclusiva de{" "}
                    <strong>PAPA ABDUL</strong>. Salvo que se indique
                    explícitamente en este documento, no se considerará que nada
                    en estos Términos crea una licencia en o bajo ninguno de
                    dichos Derechos de Propiedad Intelectual, y tu aceptas no
                    vender, licenciar, alquilar, modificar, distribuir, copiar,
                    reproducir, transmitir, exhibir públicamente, realizar
                    públicamente, publicar, adaptar, editar o crear trabajos
                    derivados de los mismos.
                  </li>
                  <li className="roman">
                    <br />
                    En la máxima medida permitida por la ley aplicable, en
                    ningún caso el [propietario de la página web] será
                    responsable por daños indirectos, punitivos, incidentales,
                    especiales, consecuentes o ejemplares, incluidos, entre
                    otros, daños por pérdida de beneficios, buena voluntad, uso,
                    datos. u otras pérdidas intangibles, que surjan de o estén
                    relacionadas con el uso o la imposibilidad de utilizar el
                    servicio. En la máxima medida permitida por la ley
                    aplicable, [el propietario la página web] no asume
                    responsabilidad alguna por (i) errores, errores o
                    inexactitudes de contenido; (ii) lesiones personales o daños
                    a la propiedad, de cualquier naturaleza que sean, como
                    resultado de tu acceso o uso de nuestro servicio; y (iii)
                    cualquier acceso no autorizado o uso de nuestros servidores
                    seguros y / o toda la información personal almacenada en los
                    mismos.
                  </li>
                  <li className="roman">
                    <br />
                    Nos reservamos el derecho de modificar estos términos de vez
                    en cuando a nuestra entera discreción. Por lo tanto, debes
                    revisar estas páginas periódicamente. Cuando cambiemos los
                    Términos de una manera material, te notificaremos que se han
                    realizado cambios importantes en los Términos. El uso
                    continuado de la página web o nuestro servicio después de
                    dicho cambio constituye tu aceptación de los nuevos
                    Términos. Si no aceptas alguno de estos términos o cualquier
                    versión futura de los Términos, no uses o accedas (o
                    continúes accediendo) a la página web o al servicio.
                  </li>
                  <li className="roman">
                    <br />
                    Acepta recibir de vez en cuando nuestros mensajes y
                    materiales de promoción, por correo postal, correo
                    electrónico o cualquier otro formulario de contacto que nos
                    proporciones (incluido tu número de teléfono para llamadas o
                    mensajes de texto). Si no deseas recibir dichos materiales o
                    avisos de promociones, simplemente avísanos en cualquier
                    momento.
                  </li>
                  <li className="roman">
                    <br />
                    Usted acuerda indemnizar y eximir de responsabilidad a
                    [propietario del sitio webbbbbbbbbb] de cualquier demanda,
                    pérdida, responsabilidad, reclamación o gasto (incluidos los
                    honorarios de abogados) que terceros realicen en tu contra
                    como consecuencia de, o derivado de, o en relación con tu
                    uso de la página web o cualquiera de los servicios ofrecidos
                    en la página web
                  </li>
                  <li className="roman">
                    <br />
                    Estos Términos, los derechos y recursos provistos aquí, y
                    todos y cada uno de los reclamos y disputas relacionados con
                    este y / o los servicios, se regirán, interpretarán y
                    aplicarán en todos los aspectos única y exclusivamente de
                    conformidad con las leyes sustantivas internas de [ Nombre
                    del país / estado], sin respeto a sus principios de
                    conflicto de leyes. Todos los reclamos y disputas se
                    presentarán y usted acepta que sean decididos exclusivamente
                    por un tribunal de jurisdicción competente ubicada en
                    [Nombre de la ciudad de los tribunales]. La aplicación de la
                    Convención de Contratos de las Naciones Unidas para la Venta
                    Internacional de Bienes queda expresamente excluida.
                  </li>
                  <li className="roman">
                    <br />
                    Podemos, sin aviso previo, cambiar los servicios; dejar de
                    proporcionar los servicios o cualquier característica de los
                    servicios que ofrecemos; o crear límites para los servicios.
                    Podemos suspender de manera permanente o temporal el acceso
                    a los servicios sin previo aviso ni responsabilidad por
                    cualquier motivo, o sin ningún motivo.
                  </li>
                  <li className="roman">
                    <br />- Violaciones del Sistema o Bases de Datos No está
                    permitida ninguna acción o uso de dispositivo, software, u
                    otro medio tendiente a interferir tanto en las actividades y
                    operatoria de SANID como en las ofertas, descripciones,
                    cuentas o bases de datos de SANID. Cualquier intromisión,
                    tentativa o actividad violatoria o contraria a las leyes
                    sobre derecho de propiedad intelectual y/o a las
                    prohibiciones estipuladas en este contrato harán pasible a
                    su responsable de las acciones legales pertinentes, y a las
                    sanciones previstas por este acuerdo, así como lo hará
                    responsable de indemnizar los daños ocasionados.
                  </li>
                  <li className="roman">
                    <br />
                    Fallas en el sistema: SANID no se responsabiliza por
                    cualquier daño, perjuicio o pérdida al usuario causados por
                    fallas en el sistema, en el servidor o en Internet. SANID
                    tampoco será responsable por cualquier virus que pudiera
                    infectar el equipo del usuario como consecuencia del acceso,
                    uso o examen de su sitio web o a raíz de cualquier
                    transferencia de datos, archivos, imágenes, textos, o audio
                    contenidos en el mismo. Los usuarios NO podrán imputarle
                    responsabilidad alguna ni exigir pago por lucro cesante, en
                    virtud de perjuicios resultantes de dificultades técnicas o
                    fallas en los sistemas o en Internet. SANID no garantiza el
                    acceso y uso continuado o ininterrumpido de su sitio. El
                    sistema puede eventualmente no estar disponible debido a
                    dificultades técnicas o fallas de Internet, o por cualquier
                    otra circunstancia ajena a SANID; en tales casos se
                    procurará restablecerlo con la mayor celeridad posible sin
                    que por ello pueda imputársele algún tipo de
                    responsabilidad. SANID no será responsable por ningún error
                    u omisión contenidos en su sitio web.
                  </li>
                  <li className="roman">
                    <br />
                    Para usar nuestro página web y / o recibir nuestros
                    servicios, debes tener al menos 16 años de edad, o la
                    mayoría de edad legal en tu jurisdicción, y poseer la
                    autoridad legal, el derecho y la libertad para participar en
                    estos Términos como un acuerdo vinculante. No tienes
                    permitido utilizar esta página web y / o recibir servicios
                    si hacerlo está prohibido en tu país o en virtud de
                    cualquier ley o regulación aplicable a tu caso.
                  </li>
                  <li className="roman">
                    <br />
                    El uso del sitio y/o sus servicios implica la aceptación de
                    estos Términos y Condiciones generales de uso de SANID.
                  </li>
                  <li className="roman">
                    <br />
                    Jurisdicción y Ley Aplicable Este acuerdo estará regido en
                    todos sus puntos por las leyes vigentes en la República
                    Argentina. Cualquier controversia derivada del presente
                    acuerdo, su existencia, validez, interpretación, alcance o
                    cumplimiento, será sometida ante la Justicia Nacional
                    Ordinaria. Si tienes alguna duda sobre los Términos y
                    Condiciones Generales o demás políticas y principios que
                    rigen SANID consultános por alguno de nuestros portales de
                    contácto.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default PrivTerm;
